var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVolume(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.40233 11.7724C6.43265 10.2986 6.44781 9.5617 6.9447 8.93088C7.03539 8.81574 7.16846 8.67893 7.27999 8.58617C7.89105 8.07791 8.69782 8.07791 10.3114 8.07791C10.8878 8.07791 11.1761 8.07791 11.4508 8.00359C11.5079 7.98815 11.5644 7.97035 11.6202 7.95022C11.8885 7.85337 12.1292 7.68667 12.6105 7.35327C14.5095 6.03788 15.459 5.38019 16.2559 5.6659C16.4087 5.72068 16.5566 5.79975 16.6887 5.89727C17.3777 6.40593 17.43 7.58938 17.5347 9.95628C17.5735 10.8327 17.5999 11.5828 17.5999 12C17.5999 12.4172 17.5735 13.1673 17.5347 14.0437C17.43 16.4106 17.3777 17.594 16.6887 18.1027C16.5566 18.2002 16.4087 18.2793 16.2559 18.3341C15.459 18.6198 14.5095 17.9621 12.6105 16.6467C12.1292 16.3133 11.8885 16.1466 11.6202 16.0497C11.5644 16.0296 11.5079 16.0118 11.4508 15.9964C11.1761 15.922 10.8878 15.922 10.3114 15.922C8.69782 15.922 7.89105 15.922 7.27999 15.4138C7.16846 15.321 7.03539 15.1842 6.9447 15.0691C6.44781 14.4383 6.43265 13.7014 6.40233 12.2276C6.40074 12.1502 6.3999 12.0742 6.3999 12C6.3999 11.9258 6.40074 11.8498 6.40233 11.7724Z",
    fill: "#8E092E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolume);
export default __webpack_public_path__ + "static/media/Volume.83f7f8a27d675c6a8419519c32e4f1c4.svg";
export { ForwardRef as ReactComponent };